export const POS_WS_URL = process.env.VUE_APP_POS_WS_URL;
